import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Shield of California",
  shortName: "Blue Shield CA",
  slug: "blue-shield-ca-insurance",
  seoTitle:
    "Blue Shield of California TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Shield of California policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Blue Shield California TMS coverage, Blue Shield CA SPRAVATO authorization, Blue Shield CA mental health benefits Coral Springs FL, Blue Shield California depression treatment Florida",
};

export const BlueShieldCaInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default BlueShieldCaInsurance;
